var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    rx: 8,
    fill: "#FFF9CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 35C27.1819 35 28.3522 34.7672 29.4442 34.3149C30.5361 33.8626 31.5282 33.1997 32.364 32.364C33.1997 31.5282 33.8626 30.5361 34.3149 29.4442C34.7672 28.3522 35 27.1819 35 26C35 24.8181 34.7672 23.6478 34.3149 22.5558C33.8626 21.4639 33.1997 20.4718 32.364 19.636C31.5282 18.8003 30.5361 18.1374 29.4442 17.6851C28.3522 17.2328 27.1819 17 26 17M26 35C24.8181 35 23.6478 34.7672 22.5558 34.3149C21.4639 33.8626 20.4718 33.1997 19.636 32.364C18.8003 31.5282 18.1374 30.5361 17.6851 29.4442C17.2328 28.3522 17 27.1819 17 26C17 24.8181 17.2328 23.6478 17.6851 22.5558C18.1374 21.4639 18.8003 20.4718 19.636 19.636C20.4718 18.8003 21.4639 18.1374 22.5558 17.6851C23.6478 17.2328 24.8181 17 26 17M26 35C28.761 35 29.941 29.837 29.941 26C29.941 22.163 28.761 17 26 17M26 35C23.239 35 22.059 29.837 22.059 26C22.059 22.163 23.239 17 26 17M17.5 23H34.5M17.5 29H34.5",
    stroke: "#ECD35F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeLogo);
export default __webpack_public_path__ + "static/media/globeLogo.c9a58d303b2ff0cd62e5ec6182f0e924.svg";
export { ForwardRef as ReactComponent };